import { AmenityReservation } from 'api/get-amenity-reservation';

import * as S from './amenity-reservation-slot.styled';
import { formatTimeRange } from '../utils';

interface AmenityReservationSlotProps {
  reservation: AmenityReservation;
  interval: number;
  capacity: number;
}

export const AmenityReservationSlot = ({ reservation, interval, capacity }: AmenityReservationSlotProps) => {
  const isReservationOpen = reservation.reservations < capacity;
  return (
    <S.Wrapper>
      <span>{formatTimeRange(reservation.startTime, reservation.startTime + interval)}</span>
      <S.Status $open={isReservationOpen}>{isReservationOpen ? '• Open' : '• Reserved'}</S.Status>
    </S.Wrapper>
  );
};
